import React, { useState } from "react";

const OrderCancelPage = () => {
  const order = {
    productTitle: "Samsung Galaxy S21",
    color: "White",
    storage: "128GB",
    quantity: 1,
    price: 14999,
    orderId: "ORD123456789",
    placedOn: "15 July 2025",
    paymentMode: "Online",
    status: "Processing", 
    image:
      "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/E-commerce/Products/13.webp",
  };

  // Form states
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [refundMode, setRefundMode] = useState("");

  const reasons = [
    "I have changed my Mind",
    "Price for the product has decreased",
    "Expected delivery time is very long",
    "I want to change my phone number",
    "I want to Cancel due to product quality issues",
    "I want to change address for the order",
    "I have purchased the product elsewhere",
    "Other",
  ];

  const isDisabled =
    !reason ||
    (reason === "Other" && !otherReason.trim()) ||
    (order.paymentMode === "Online" && !refundMode);

  const handleSubmit = (e) => {
    e.preventDefault();

    const finalReason = reason === "Other" ? otherReason : reason;
    const message = `
✅ Cancellation Submitted!

📦 Order ID: ${order.orderId}
🛒 Product: ${order.productTitle}
💳 Payment Mode: ${order.paymentMode}
📕 Reason: ${finalReason}
💰 Refund Mode: ${
      order.paymentMode === "Online" ? refundMode : "Not applicable"
    }
`;

    alert(message);
  };

  return (
    <div className="container myntra-order-container">
      <div className="col-md-8 mx-auto card shadow p-4">
        <h4 className="mb-4 text-danger">Order Cancellation</h4>

        {/* === ORDER DETAIL SECTION === */}
        <div className="d-flex mb-4 align-items-center">
          <img
            src={order.image}
            alt={order.productTitle}
            style={{ width: "90px", borderRadius: "10px" }}
            className="me-3"
          />
          <div>
            <h6 className="mb-1">{order.productTitle}</h6>
            <p className="mb-0 text-muted small">
              {order.color} | {order.storage}
            </p>
            <p className="mb-0 text-muted small">
              Qty: {order.quantity} | ₹{order.price}
            </p>
            <p className="mb-0 text-muted small">
              Order ID: {order.orderId} | Placed on: {order.placedOn}
            </p>
            <p className="mb-0 text-muted small">
              Payment Mode: {order.paymentMode}
            </p>
            <p className="mb-0 text-muted small">
              Current Status:{" "}
              <span className="fw-semibold text-capitalize">{order.status}</span>
            </p>
          </div>
        </div>

        <hr />

        {/* === CANCELLATION FORM === */}
        {order.status === "Shipped" || order.status === "Delivered" ? (
          <div className="alert alert-warning">
            ❌ You cannot cancel this order. It has already been{" "}
            <strong>{order.status}</strong>.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-bold">
                Select a Cancellation Reason
              </label>
              {reasons.map((r, i) => (
                <div className="form-check" key={i}>
                  <input
                    className="form-check-input"
                    type="radio"
                    id={`reason-${i}`}
                    name="reason"
                    value={r}
                    checked={reason === r}
                    onChange={(e) => setReason(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor={`reason-${i}`}>
                    {r}
                  </label>
                </div>
              ))}
            </div>

            {reason === "Other" && (
              <div className="mb-3">
                <label className="form-label">Please specify:</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={otherReason}
                  onChange={(e) => setOtherReason(e.target.value)}
                  placeholder="Enter your reason here..."
                />
              </div>
            )}

            {order.paymentMode === "Online" && (
              <div className="mb-3">
                <label className="form-label fw-bold">Refund to:</label>
                <div className="form-check">
                  <input
                    type="radio"
                    id="refund-original"
                    name="refund"
                    value="Original Payment Mode"
                    className="form-check-input"
                    checked={refundMode === "Original Payment Mode"}
                    onChange={(e) => setRefundMode(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="refund-original">
                    Original Payment Mode
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    id="refund-wallet"
                    name="refund"
                    value="Mumbaishopper Wallet"
                    className="form-check-input"
                    checked={refundMode === "Mumbaishopper Wallet"}
                    onChange={(e) => setRefundMode(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="refund-wallet">
                    Mumbaishopper Wallet
                  </label>
                </div>
              </div>
            )}

            <button
              type="submit"
              className="btn btn-danger mt-2"
              disabled={isDisabled}
            >
              Submit Cancellation
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default OrderCancelPage;
